export namespace BellmereQA {
  export type Results = {
    annotations?: AnnotationResult[],
    feedback_summaries?: FeedbackSummaryResult[],
  } & SummaryResult;

  export type AnnotationResult = {
    submission_annotation_id: string,
    action: ActionState,
    highlight_range_correct: boolean,
    areas_for_improvement: {
      comment_helper_id: integer, correct: boolean
    }[],
    example_quality_acceptable: boolean,
    explanation_quality_acceptable: boolean,
    comments: string
  }

  export type FeedbackSummaryResult = {
    feedback_summary_id: string,
    action: ActionState,
    comments: string
  }

  export enum ActionState {
    FineToShow = 'fine_to_show',
    HesitateToShow = 'hesitate_to_show',
    DoNotShow = 'do_not_show'
  }

  export type SummaryResult = {
    emotionally_at_risk?: boolean,
    academically_at_risk?: boolean,
    low_rated?: boolean,
    general_comments?: string
    additional_flag?: string[]
  }

  export const isAnnotationResult = (
    result: AnnotationResult | FeedbackSummaryResult
  ): result is AnnotationResult => 'submission_annotation_id' in result;

  export type HeaderData = {
    clientName: string;
    clientResources: string[];
    documentName: string;
    documentType: string;
    documentUrl: string;
    language: string;
    progress: string;
    qaAcceptedAt: string;
    reasonsForReview: string[];
    referenceStyle: string;
    studentComment: string;
    studentRating: string;
    submittedAt: string;
    taskDescription: string;
    uuid: string;
    wordCount: number;
    qaLeadComment: string;
  };
}
